import React, { useEffect, useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Studio',
    href: '#studio'
  }, {
    name: 'Approach',
    href: '#approach'
  }, {
    name: 'Ventures',
    href: '#ventures'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/95 backdrop-blur-md py-2 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-139">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-140">
        <a href="#" className="flex items-center gap-2 z-50" data-id="element-141">
          <img src="https://cdn.magicpatterns.com/uploads/uJ1Trq7SuNbdwizbCqPRU7/launchcave_logo.png" alt="LaunchCave Logo" className={`w-auto object-contain transition-all duration-300 ${isScrolled ? 'h-12 md:h-14' : 'h-12 md:h-14'}`} data-id="element-142" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-143">
          <ul className="flex items-center gap-8 text-sm font-medium" data-id="element-144">
            {navLinks.map(link => <li key={link.name} data-id="element-145">
                <a href={link.href} className="hover:text-orange transition-colors duration-200" data-id="element-146">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="#contact" className="group flex items-center gap-2 bg-orange text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-orange-hover transition-all duration-300" data-id="element-147">
            Work with us
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-148" />
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden z-50 text-navy" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-149">
          {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-150" /> : <Menu className="w-6 h-6" data-id="element-151" />}
        </button>

        {/* Mobile Nav */}
        <AnimatePresence data-id="element-152">
          {mobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="absolute top-0 left-0 w-full h-screen bg-cream flex flex-col items-center justify-center gap-8 z-40" data-id="element-153">
              <ul className="flex flex-col items-center gap-6 text-2xl font-serif" data-id="element-154">
                {navLinks.map(link => <li key={link.name} data-id="element-155">
                    <a href={link.href} onClick={() => setMobileMenuOpen(false)} className="hover:text-orange transition-colors" data-id="element-156">
                      {link.name}
                    </a>
                  </li>)}
              </ul>
              <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="bg-orange text-white px-8 py-4 rounded-full text-lg font-medium mt-4" data-id="element-157">
                Work with us
              </a>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}